/**
 * Sparkline — tiny inline chart for trends (slow-steps table, service strip).
 *
 * Renders 9 points by default. `isUp` triggers amber accent for steps
 * trending worse. SVG-only (no uPlot) so it stays lightweight at the
 * many-rows-per-page scale.
 *
 * Props:
 *   points:   number[] (oldest → newest)
 *   isUp?:    boolean — amber stroke + fill when true
 *   width?:   default 60
 *   height?:  default 18
 */

const ACCENT = 'rgba(104,255,154,1)';
const ACCENT_FILL = 'rgba(104,255,154,0.18)';
const AMBER = 'rgba(255,179,90,1)';
const AMBER_FILL = 'rgba(255,179,90,0.20)';

export default function Sparkline({ points, isUp = false, width = 60, height = 18 }) {
  if (!Array.isArray(points) || points.length === 0) {
    return <svg width={width} height={height} aria-hidden="true" />;
  }
  const stroke = isUp ? AMBER : ACCENT;
  const fill = isUp ? AMBER_FILL : ACCENT_FILL;
  const min = Math.min(...points);
  const max = Math.max(...points);
  const span = Math.max(1, max - min);
  const x = (i) => (i / (points.length - 1 || 1)) * width;
  const y = (v) => height - 1 - ((v - min) / span) * (height - 2);
  const line = points.map((v, i) => `${i === 0 ? 'M' : 'L'}${x(i).toFixed(1)} ${y(v).toFixed(1)}`).join(' ');
  const area = `${line} L${width} ${height} L0 ${height} Z`;
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      aria-hidden="true"
      style={{ display: 'block' }}
    >
      <path d={area} fill={fill} />
      <path d={line} stroke={stroke} strokeWidth="1.2" fill="none" />
    </svg>
  );
}
